module.exports = __webpack_public_path__ + "static/img/8.db09d85.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/8.png
// module id = SRKJ
// module chunks = 1